import React, { useState, useEffect } from "react";
import { nanoid } from "nanoid";
import { isValidPhoneNumber } from "libphonenumber-js/min";
import determineBrandMatch from "./businessLogic";

const withSlideState = (Component) => (props) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [answers, setAnswers] = useState({});
  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [manualNavigation, setManualNavigation] = useState(false);
  const [checkBoxes, setCheckBoxes] = useState({ first: true, second: false });
  const [inputErrors, setInputErros] = useState({
    firstName: false,
    lastName: false,
    phoneNumber: false,
    email: false,
    zip: false,
  });

  const slides = props.slides;

  const initializeAnswers = () => {
    const initialAnswers = { submissionId: nanoid(12) };
    slides.forEach((slide) => {
      if (slide.type === "multiple-fields") {
        slide.fields.forEach((field) => {
          initialAnswers[field.key] = "";
        });
      } else {
        initialAnswers[slide.key] = "";
      }
    });

    // new aid process
    const params = new URLSearchParams(document.location.search);
    if (params.get('ref')) {
      const ref = params.get('ref');

      initialAnswers['queryparam_ref'] = ref;
    }
    initialAnswers['loc'] = window.location.toString();

    // // // Set aid from referer
    // // if (document.referrer) {
    // //   try {
    // //     const refUrl = new URL(document.referrer);
    // //     const refPath = refUrl.pathname;

    // //     if (refUrl.host == 'www.ncoa.org' || refUrl.host == 'medical-guardian.com') {
    // //       // if u contains querystring aid extract it
    // //       let aid = new URL(window.location).searchParams.get('aid');
    // //       if (!aid) aid = refUrl.searchParams.get('aid');

    // //       if (aid) {
    // //         const pathToCampaign = {
    // //           '4735':'NCOA - Best Medical Alert Systems',
    // //           '4736':'NCOA - Best MAS w/ Fall Detection',
    // //           '4737':'NCOA - MG Brand Review',
    // //           '4738':'NCOA - Best MAS Watches',
    // //           '4739':'NCOA - Best MAS w/ GPS',
    // //           '4796':'NCOA - Best MAS Necklace',
    // //           '4947':'NCOA - Medical Alert Systems Cost',
    // //           '4948':'NCOA - Life Alert Review',
    // //           '4949':'NCOA - Best Medical Alert Bracelets',
    // //           '4951':'NCOA - Life Alert vs Medical Guardian',
    // //         };
    // //         const campaignId = pathToCampaign[aid];

    // //         initialAnswers['aid'] = aid;
    // //         if (campaignId) initialAnswers['campaignId'] = campaignId;


    // //         let utm_source = new URL(window.location).searchParams.get('utm_source');
    // //         let utm_medium = new URL(window.location).searchParams.get('utm_medium');
    // //         let utm_campaign = new URL(window.location).searchParams.get('utm_campaign');

    // //         if (!utm_source) {
    // //           utm_source = refUrl.searchParams.get('utm_source');
    // //           utm_medium = refUrl.searchParams.get('utm_medium');
    // //           utm_campaign = refUrl.searchParams.get('utm_campaign'); 
    // //         }

    // //         if (utm_source) initialAnswers['utm_source'] = utm_source;
    // //         if (utm_medium) initialAnswers['utm_medium'] = utm_medium;
    // //         if (utm_campaign) initialAnswers['utm_campaign'] = utm_campaign;

    // //         if (aid || utm_source || utm_medium || utm_campaign) {
    // //           initialAnswers['organic'] = 'true';
    // //         }
    // //       }
    // //     } else {
    // //       switch (refPath) {
    // //         case '/best-medical-alert-systems-nb-2/':
    // //           initialAnswers['aid'] = '4611';
    // //           initialAnswers['campaignId'] = 'NCOA - PPC 3';
    // //           break;
    // //         case '/best-medical-alert-systems-nb-3/':
    // //           initialAnswers['aid'] = '4534';
    // //           initialAnswers['campaignId'] = 'NCOA - PPC 4';
    // //           break;
    // //         case '/best-medical-alert-systems-nb-4/':
    // //           initialAnswers['aid'] = '4526';
    // //           initialAnswers['campaignId'] = 'NCOA - PPC 5';
    // //           break;
    // //         case '/best-medical-alert-systems-nb-5/':
    // //           initialAnswers['aid'] = '4326';
    // //           initialAnswers['campaignId'] = 'NCOA - PPC 6';
    // //           break;
    // //         case '/best-medical-alert-systems-nb-6/':
    // //           initialAnswers['aid'] = '4352';
    // //           initialAnswers['campaignId'] = 'NCOA - PPC 7';
    // //           break;
    // //         case '/best-medical-alert-systems-nb-7/':
    // //           initialAnswers['aid'] = '5122';
    // //           initialAnswers['campaignId'] = 'NCOA - PPC 8';
    // //           break;
    // //         case '/best-medical-alert-systems-nb-8/':
    // //           initialAnswers['aid'] = '5153';
    // //           initialAnswers['campaignId'] = 'NCOA - PPC 9';
    // //           break;
    // //         case '/best-medical-alert-systems-nb-9/':
    // //           initialAnswers['aid'] = '5154';
    // //           initialAnswers['campaignId'] = 'NCOA - PPC 10';
    // //           break;
    // //         case '/best-medical-alert-systems-nb-10/':
    // //           initialAnswers['aid'] = '5155';
    // //           initialAnswers['campaignId'] = 'NCOA - PPC 11';
    // //           break;
    // //         case '/best-medical-alert-systems-nb-11/':
    // //           initialAnswers['aid'] = '5156';
    // //           initialAnswers['campaignId'] = 'NCOA - PPC 12';
    // //           break;
    // //         case '/best-medical-alert-systems-nb-12/':
    // //           initialAnswers['aid'] = '5157';
    // //           initialAnswers['campaignId'] = 'NCOA - PPC 13';
    // //           break;
    // //         case '/best-medical-alert-systems-pmax-d/':
    // //           initialAnswers['aid'] = '5158';
    // //           initialAnswers['campaignId'] = 'NCOA - PPC 14';
    // //           break;
    // //         case '/best-medical-alert-systems-pmax-m/':
    // //           initialAnswers['aid'] = '5159';
    // //           initialAnswers['campaignId'] = 'NCOA - PPC 15';
    // //           break;

    // //         case '/adviser/medical-alert-systems/best-medical-alert-systems':
    // //           initialAnswers['aid'] = '4735';
    // //           initialAnswers['campaignId'] = 'NCOA - Best Medical Alert Systems';
    // //           break;
    // //         case '/adviser/medical-alert-systems/best-medical-alert-systems-fall-detection':
    // //           initialAnswers['aid'] = '4736';
    // //           initialAnswers['campaignId'] = 'NCOA - Best MAS w/ Fall Detection';
    // //           break;
    // //         case '/adviser/medical-alert-systems/medical-guardian-review/':
    // //           initialAnswers['aid'] = '4737';
    // //           initialAnswers['campaignId'] = 'NCOA - MG Brand Review';
    // //           break;
    // //         case '/adviser/medical-alert-systems/best-medical-alert-watches/':
    // //           initialAnswers['aid'] = '4738';
    // //           initialAnswers['campaignId'] = 'NCOA - Best MAS Watches';
    // //           break;
    // //         case '/adviser/medical-alert-systems/best-medical-alert-systems-with-gps/':
    // //           initialAnswers['aid'] = '4739';
    // //           initialAnswers['campaignId'] = 'NCOA - Best MAS w/ GPS';
    // //           break;
    // //         case '/adviser/medical-alert-systems/best-medical-alert-necklace/':
    // //           initialAnswers['aid'] = '4796';
    // //           initialAnswers['campaignId'] = 'NCOA - Best MAS Necklace';
    // //           break;
    // //         case '/adviser/medical-alert-systems/medical-alert-systems-cost/':
    // //           initialAnswers['aid'] = '4947';
    // //           initialAnswers['campaignId'] = 'NCOA - Medical Alert Systems Cost';
    // //           break;
    // //         case '/adviser/medical-alert-systems/life-alert-review':
    // //           initialAnswers['aid'] = '4948';
    // //           initialAnswers['campaignId'] = 'NCOA - Life Alert Review';
    // //           break;
    // //         case '/adviser/medical-alert-systems/best-medical-alert-bracelets/':
    // //           initialAnswers['aid'] = '4949';
    // //           initialAnswers['campaignId'] = 'NCOA - Best Medical Alert Bracelets';
    // //           break;
    // //         case '/adviser/medical-alert-systems/life-alert-vs-medical-guardian/':
    // //           initialAnswers['aid'] = '4951';
    // //           initialAnswers['campaignId'] = 'NCOA - Life Alert vs Medical Guardian';
    // //           break;

    // //         default:
    // //           initialAnswers['aid'] = '4386';
    // //           initialAnswers['campaignId'] = 'NCOA - PPC 1';
    // //       }
    // //     }

    // //     // write aid and campaignId to localstorage
    // //     localStorage.setItem('aid', initialAnswers['aid']);
    // //     localStorage.setItem('campaignId', initialAnswers['campaignId']);
    // //   } catch (e) {
    // //     console.error(e);
    // //   }
    // // } else {
    // //   // check if there are aid and campaignId in localstorage. if found set those values in initialAnswers
    // //   const aid = localStorage.getItem('aid');
    // //   const campaignId = localStorage.getItem('campaignId');
      
    // //   if (aid) {
    // //     initialAnswers['aid'] = aid;
    // //   } else {
    // //     initialAnswers['aid'] = '4386';
    // //   }

    // //   if (campaignId) {
    // //     initialAnswers['campaignId'] = campaignId;
    // //   } else {
    // //     initialAnswers['campaignId'] = 'NCOA - PPC 1';
    // //   }
    // // }

    return initialAnswers;
  };

  useEffect(() => {
    setAnswers(initializeAnswers());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const currentSlideData = slides[currentSlide];
    if (currentSlideData && currentSlideData.key) {
      window.history.pushState(null, "", `#${currentSlideData.key}`);
    }
  }, [currentSlide, slides]);

  useEffect(() => {
    const currentSlideData = slides[currentSlide];
    if (currentSlideData && currentSlideData.key) {
      if (currentSlide > 0) {
        try {
          fetch("/hyroad/f/", {
            keepalive: true,
            method: "POST",
            cache: "no-cache",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              title: document.title,
              uad: navigator.userAgentData,
              referrer: document.referrer,
              dt: new Date().toISOString(),
              a: answers,
              hash: currentSlideData.key,
            }),
          });
        } catch {
          /* no-op */
        }
      }
    }
  }, [currentSlide, slides, answers]);

  const onCheckBoxChange = (key, checked) => {
    setCheckBoxes((prev) => ({ ...prev, [key]: checked }));
  };

  const goToSlide = (slideIndex) => {
    if (slideIndex >= 0 && slideIndex < slides.length) {
      setCurrentSlide(slideIndex);
    }
  };

  const nextSlide = () => {
    setManualNavigation(true);
    const currentSlideData = slides[currentSlide];
    if (!currentSlideData) return;

    if (currentSlideData.type === "multiple-fields") {
      const missingFields = currentSlideData.fields.reduce((acc, field) => {
        const value = answers[field.key] || "";
        let hasError = false;

        if (value.trim() === "") hasError = true;

        if (field.key === "email" && value.trim() !== "") {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailRegex.test(value)) hasError = true;
        }

        if (field.type === "tel" && value.trim() !== "") {
          if (!isValidPhoneNumber(value.trim(), "US")) hasError = true;
        }

        if (hasError) acc[field.key] = true;
        return acc;
      }, {});

      if (Object.keys(missingFields).length > 0) {
        setInputErros((prev) => ({ ...prev, ...missingFields }));
        setErrors((prev) => ({ ...prev, ...missingFields }));
        return;
      }
    } else {
      const currentKey = currentSlideData?.key;
      const value = answers[currentKey] || "";

      if (value.trim() === "" || inputErrors[currentKey]) {
        setErrors((prev) => ({ ...prev, [currentKey]: true }));
        setInputErros((prev) => ({ ...prev, [currentKey]: true }));
        return;
      }

      // Skip logic for "lastTest" if "hearingTest" is "No"
      if (currentKey === "hearingTest" && answers[currentKey] === "No") {
        const nextSlideIndex = slides.findIndex((slide) => slide.key === "lastTest");
        if (nextSlideIndex > -1) {
          setAnswers((prev) => ({ ...prev, lastTest: "Over a year ago" }));
          goToSlide(nextSlideIndex + 1);
          return;
        }
      }
    }

    goToSlide(currentSlide + 1);
  };

  const updateAnswer = (key, value) => {
    setAnswers((prev) => ({ ...prev, [key]: value }));

    // Clear both error maps for this key
    setErrors((prev) => ({ ...prev, [key]: false }));
    setInputErros((prev) => ({ ...prev, [key]: false }));

    // Trigger skipping logic directly for immediate effect
    if (key === "hearingTest" && value === "No") {
      const nextSlideIndex = slides.findIndex((slide) => slide.key === "lastTest");
      if (nextSlideIndex > -1) {
        setAnswers((prev) => ({ ...prev, lastTest: "Over a year ago" }));
        setManualNavigation(true);
        goToSlide(nextSlideIndex + 1);
        return;
      }
    }
  };

  // Auto-advance: only on non-multiple-fields, non-last slides
  useEffect(() => {
    if (manualNavigation) {
      setManualNavigation(false);
      return;
    }

    const currentSlideData = slides[currentSlide];
    const isLast = currentSlide === slides.length - 1;
    const isMulti = currentSlideData?.type === "multiple-fields";
    const currentKey = currentSlideData?.key;

    if (!isLast && !isMulti && currentKey && answers[currentKey]) {
      nextSlide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [answers, currentSlide, slides]);

  const prevSlide = () => {
    setManualNavigation(true);
    setCurrentSlide((prev) => Math.max(prev - 1, 0));
    const currentKey = slides[Math.max(currentSlide - 1, 0)]?.key;

    if (currentKey && errors[currentKey]) {
      setErrors((prevErrors) => {
        const updated = { ...prevErrors };
        delete updated[currentKey];
        return updated;
      });
    }
  };

  const submitForm = async () => {
    // Flatten answers
    const sanitizedAnswers = slides.reduce((acc, slide) => {
      if (slide.type === "multiple-fields") {
        slide.fields.forEach((field) => {
          const v = answers[field.key];
          acc[field.key] = (v ?? "").toString();
        });
      } else {
        const v = answers[slide.key];
        acc[slide.key] = ((v ?? "").toString().trim() || "skipped");
      }
      return acc;
    }, {});

    // sanitizedAnswers['aid'] = answers['aid'];
    // sanitizedAnswers['campaignId'] = answers['campaignId'];
    sanitizedAnswers['submissionId'] = answers['submissionId'];
    //sanitizedAnswers['utm_source'] = answers['utm_source'];
    //sanitizedAnswers['utm_campaign'] = answers['utm_campaign'];
    //sanitizedAnswers['utm_medium'] = answers['utm_medium'];
    // sanitizedAnswers['organic'] = answers['organic'];
    sanitizedAnswers['queryparam_ref'] = answers['queryparam_ref'];
    sanitizedAnswers['loc'] = answers['loc'];

    // Add SMS checkbox "first" and "second" values to sanitizedAnswers for submission
    sanitizedAnswers['sms_first'] = checkBoxes.first;
    //sanitizedAnswers['sms_second'] = checkBoxes.second;

    // Derive required fields from the actual last slide if it's multiple-fields
    const lastSlide = slides[slides.length - 1];
    const isLastMulti = lastSlide?.type === "multiple-fields";
    const requiredFields = isLastMulti
      ? lastSlide.fields
          .filter((f) => f.required !== false) // treat `required: false` as optional
          .map((f) => f.key)
      : ["firstName", "lastName", "phoneNumber", "email", "zip"]; // fallback if last isn't multi

    // Build error map for required fields
    const newInputErrors = requiredFields.reduce((acc, field) => {
      const val = (sanitizedAnswers[field] ?? "").toString().trim();
      if (!val) acc[field] = true;
      return acc;
    }, {});

    // Email format (only if "email" is one of the required fields)
    if (requiredFields.includes("email")) {
      const email = (sanitizedAnswers.email ?? "").toString().trim();
      if (email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
          newInputErrors.email = true;
        }
      }
    }

    // Phone format (find the tel-type field from the CMS config, since its key isn't guaranteed to be "phoneNumber")
    const telField = isLastMulti ? lastSlide.fields.find((f) => f.type === "tel") : null;
    if (telField) {
      const phoneNumber = (sanitizedAnswers[telField.key] ?? "").toString().trim();
      if (phoneNumber && !isValidPhoneNumber(phoneNumber, "US")) {
        newInputErrors[telField.key] = true;
      }
    }

    if (Object.keys(newInputErrors).length > 0) {
      setInputErros((prev) => ({ ...prev, ...newInputErrors }));
      return;
    }


    const submissionResults = await determineBrandMatch(sanitizedAnswers);
    
    setIsSubmitted(true);

    // This success page lives in WordPress
    // redirect to https://medical-guardian.com/free-quote/success/
    window.location = 'https://medical-guardian.com/free-quote/success/';
  };

  return (
    <Component
      {...props}
      answers={answers}
      inputErrors={inputErrors}
      currentSlide={currentSlide}
      updateAnswer={updateAnswer}
      nextSlide={nextSlide}
      prevSlide={prevSlide}
      submitForm={submitForm}
      errors={errors}
      isSubmitted={isSubmitted}
      checkBoxes={checkBoxes}
      onCheckBoxChange={onCheckBoxChange}
    />
  );
};

export default withSlideState;
